<template>
  <div id="app" :class="{ 'sidebar-collapsed': isCollapsed }" :style="appStyle">
    <TheSidebar @toggle="onSidebarToggle" />
    <main class="main-content">
      <router-view />
    </main>
  </div>
</template>

<script>
import TheSidebar from './components/TheSidebar.vue';

export default {
  name: 'App',
  components: { TheSidebar },
  data() {
    return { isCollapsed: true };
  },
  computed: {
    appStyle() {
      const sidebarWidth = this.isCollapsed ? '72px' : '240px';
      return {
        '--sidebar-width': sidebarWidth
      };
    }
  },
  methods: {
    onSidebarToggle(collapsed) {
      this.isCollapsed = collapsed;
    }
  }
};
</script>

<style>
html, body {
  margin: 0;
  padding: 0;
}
#app {
  font-family: 'Microsoft YaHei', 'PingFang SC', 'Hiragino Sans GB', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #1e293b;
  display: flex;
  min-height: 100vh;
}
.main-content {
  flex: 1;
  margin-left: 240px;
  min-width: 0;
  transition: margin-left 0.3s ease;
}
#app.sidebar-collapsed .main-content {
  margin-left: 72px;
}
@media (max-width: 768px) {
  #app {
    flex-direction: column;
  }
  .main-content,
  #app.sidebar-collapsed .main-content {
    margin-left: 0;
    margin-top: 56px;
  }
  #app {
    --sidebar-width: 0px;
  }
}
</style>
